// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.terms-container-stripe[data-v-f2d172f6] {\n  text-align: left;\n}\n.terms-container h3[data-v-f2d172f6]{\n  text-align: center;\n}\n", ""]);
// Exports
module.exports = exports;
